import ErrorHigia from '../domains/error-higia-dto'

export interface ErrorType {
    codigo: number
    descricao: string
}

/**
 * Serviço para tratar os diferentes tipos de erro do sistema
 */
export default class HigiaErrorSevice {
    public static DEFAULT_ERROR_MSG =
        'Desculpe, não foi possível completar a operação. Favor direcionar ocorrido à equipe do Credenciamento e Remuneração'
    public static currentRequestUrl = ''
    public static currentUrl = ''

    /**
     * Objeto que representa os tres grandes grupos de erro http
     */
    ERROR_TYPE: ErrorType[] = [
        {
            codigo: 0,
            descricao: 'critico', //Erros que não retornam status 0 (ex: cross browser)
        },
        {
            codigo: 1,
            descricao: 'negocio', //erros Cliente (>=400 & <500)
        },
        {
            codigo: 2,
            descricao: 'sistemico', //erros do Server (>=500 & <600)
        },
    ]

    /**
     *
     * @param error
     * Trata o erro que vem no response e construi um objeto organizado incluindo os erros higia
     */
    handleError(error: Response | any): ErrorHigia {
        const { status, statusText, config, data } = error

        const errMsg = statusText ?? error.toString()
        const url = config?.url ?? data?.path ?? ''
        let timestamp = ''
        let mensagemHg = ''
        let tituloHg = ''
        let mensagemRetorno: any = null

        if (data) {
            timestamp = data.timestamp

            if (data.mensagemRetorno) {
                mensagemHg = data.mensagemRetorno.mensagem
                tituloHg = data.mensagemRetorno.titulo
                mensagemRetorno = data.mensagemRetorno
            } else {
                mensagemHg = data.message || data.error
            }

            if (data.resultado && Array.isArray(data.resultado)) {
                let validacoesMsg = ''
                data.resultado.forEach((validacao, idx, validacoes) => {
                    validacoesMsg += `${validacao.defaultMessage}`
                    if (idx < validacoes.length - 1) {
                        validacoesMsg += '\n'
                    }
                })
                mensagemHg = validacoesMsg
            }
        }

        const errorTratadoHigia = new ErrorHigia(
            0,
            errMsg,
            url,
            mensagemHg,
            tituloHg,
            0,
            '',
            timestamp,
            mensagemRetorno
        )

        const hasStatus = status !== 0 || data
        const errorType = hasStatus ? (status >= 400 && status < 500 ? 1 : 2) : 0

        errorTratadoHigia.status = hasStatus ? status : 0
        errorTratadoHigia.codTipoErroHg = this.ERROR_TYPE[errorType].codigo
        errorTratadoHigia.descTipoErroHg = this.ERROR_TYPE[errorType].descricao

        return errorTratadoHigia
    }
}
